var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftItem main"},[_c('populationOverview'),_c('olderInfor'),_c('comprehensive')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }